<template>
  <div class="standard-project-form ghost-button-styles">
    <Moduler name="basic" title="基础信息">
      <el-form
        ref="basicFormRef"
        :model="projectForm"
        :rules="getProjectFormRules.call(projectForm, { standardEdit: true })"
        label-width="180px"
      >
        <el-form-item label="投放账号">
          <el-input :value="accountName" disabled style="width: 480px"></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="project_name">
          <el-input
            v-model="projectForm.project_name"
            clearable
            style="width: 480px"
            placeholder="最大90个字符，1个中文等于2个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="内部计划名称">
          <el-input :value="editContext.internalPlanName" disabled style="width: 480px"></el-input>
        </el-form-item>
        <el-form-item label="投放游戏">
          <el-input :value="editContext.gameName || editContext.gameId" disabled style="width: 480px"></el-input>
        </el-form-item>
        <el-form-item label="推广目的">
          <el-input :value="landingTypeLabel" disabled style="width: 480px"></el-input>
        </el-form-item>
        <el-form-item label="计划类型">
          <el-input :value="adTypeLabel" disabled style="width: 480px"></el-input>
        </el-form-item>
        <el-form-item label="营销场景">
          <el-input :value="marketingGoalLabel" disabled style="width: 480px"></el-input>
        </el-form-item>
        <el-form-item label="投放模式">
          <el-input :value="deliveryModeLabel" disabled style="width: 480px"></el-input>
        </el-form-item>
        <el-form-item label="监测链接">
          <el-input :value="editContext.trackChainAddr" disabled type="textarea" :rows="3" style="width: 680px"></el-input>
        </el-form-item>
      </el-form>
    </Moduler>

    <Moduler v-if="projectForm.ad_type === AD_TYPE.SEARCH" name="marketing" title="营销配置">
      <el-form :model="projectForm" label-width="180px">
        <KeywordSearchForm :form="projectForm" standard-edit>
          <template #searchBidKeywordsSelectBtn>
            <el-button type="text" @click="keywordModalVisible = true">&ensp;选择关键词</el-button>
          </template>
        </KeywordSearchForm>
      </el-form>
    </Moduler>

    <Moduler name="targeting" title="定向设置">
      <el-form :model="projectForm" label-width="180px">
        <el-form-item label="定向设置" prop="audience_type">
          <el-radio-group v-model="projectForm.audience_type">
            <el-radio-button ghost :label="PROJECT_AUDIENCE_TYPE.UNLIMITED">不限</el-radio-button>
            <el-radio-button ghost :label="PROJECT_AUDIENCE_TYPE.CUSTOM">自定义</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <ToutiaoTargetingForm
        v-if="isCustomAudience"
        ref="targetingFormRef"
        label-width="180px"
        :is-procedural="isProcedural"
        :platform-disabled="true"
        :is-v3="true"
        :ad-marketing-scene-disabled="true"
      ></ToutiaoTargetingForm>
    </Moduler>

    <Moduler name="bid" title="项目排期与出价">
      <el-form
        ref="bidFormRef"
        :model="projectForm"
        :rules="getProjectFormRules.call(projectForm, { standardEdit: true })"
        label-width="180px"
      >
        <BidForm :form="projectForm" standard-edit></BidForm>
      </el-form>
    </Moduler>

    <Moduler name="materials" title="计划与素材">
      <PlanInfoForm
        ref="planInfoFormRef"
        label-width="180px"
        :project-form="projectForm"
        :ad-account="adAccount"
        standard-edit
      >
        <template #creatives>
          <el-form-item label="创意素材" prop="selectedMaterials">
            <CreativeConfigForm
              ref="creativeFormRef"
              :form.sync="creativeForm"
              :project-form="projectForm"
              :max-count="800"
              :is-v3="true"
              :show-name="false"
              :confirm-existing-removal="true"
              :disable-existing-video-cover-replace="true"
              :skip-material-validation="true"
              @show-material-selector="onShowCreativeSelector()"
              @replace="onShowRepalceMaterialSelector"
            ></CreativeConfigForm>
          </el-form-item>
        </template>

        <template #titles="{ planForm }">
          <el-form-item label="创意标题" prop="title_material_list">
            <div
              v-for="(text, index) in planForm.title_material_list"
              :key="text.material_id ? String(text.material_id) : `new-title-${index}`"
              class="title-input-row"
            >
              <el-input v-model="text.title"></el-input>
              <span class="remove el-icon-error" @click="removeTitleItem(index)"></span>
            </div>
            <span>
              <el-button type="text" :disabled="planForm.title_material_list.length >= 10" @click="addTitleItem">
                +添加创意标题
              </el-button>
              <el-button type="text" :disabled="planForm.title_material_list.length >= 10" @click="titleSelectorModal = true">
                +选择创意标题
              </el-button>
              ({{ planForm.title_material_list.length }}/10)
            </span>
          </el-form-item>
        </template>
      </PlanInfoForm>
    </Moduler>

    <Document
      v-model="titleSelectorModal"
      :open-id="opId"
      @on-select="onTitleSelectConfirm"
      @on-cancel="titleSelectorModal = false"
    ></Document>

    <SearchBidKeywordSelectModal
      v-model="keywordModalVisible"
      :account-id="adAccount.id"
      :list="keywordSelection"
      @confirm="onKeywordConfirm"
    ></SearchBidKeywordSelectModal>

    <el-dialog
      custom-class="creative-selector-dialog"
      title="选择素材"
      width="1240px"
      :visible.sync="showSelectorModal"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="onSelectorClose"
    >
      <AssetsSelector
        v-bind="{ ...selectorProps, visible: showSelectorModal, selectedGameId: projectForm.game.id }"
        @close="onSelectorClose"
        @confirm="onSelectorConfirm"
      >
        <template v-slot:carouselAccount="{ getData }">
          <div v-show="selectorProps.assetType === MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE_AUDIO]">
            <el-input style="width: 220px" disabled :value="adAccount.adAccount"></el-input>
            <span>&ensp;</span>
            <el-button type="text" @click="showCarouselAddModal = true">+新建图文</el-button>
            <el-button type="text" @click="getData">刷新</el-button>
          </div>
          <CarouselMaterialModal
            v-model="showCarouselAddModal"
            :account-id="selectorProps.adAccountId"
            @confirm="getData"
          ></CarouselMaterialModal>
        </template>

        <template v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.VIDEO]"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
            @change="getData"
          >
            视频
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE]"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
            @change="getData"
          >
            图片
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE_AUDIO]"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE_AUDIO]"
            @change="getData"
          >
            图文
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.POSTER]"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
            @change="getData"
          >
            封面
          </el-radio>
        </template>

        <template v-slot:sizes="{ getData, width }">
          <el-select
            v-model="selectorProps.form.sizes"
            :style="{ width }"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            clearable
            multiple
            collapse-tags
            @change="getData"
          >
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </template>
      </AssetsSelector>
    </el-dialog>
  </div>
</template>

<script setup>
import Cookies from 'js-cookie'
import { clone } from '@/common/js/just.js'
import { computed, nextTick, provide, ref, watch } from 'vue'
import { MessageBox } from 'element-ui'
import Moduler from '@/components/moduler'
import KeywordSearchForm from '@/views/create/bytedance/components/project/keyword-search-form.vue'
import ToutiaoTargetingForm from '@/views/promote/targeting/components/toutiao/targeting-form.vue'
import BidForm from '@/views/create/bytedance/components/project/bid-form.vue'
import PlanInfoForm from '@/views/create/bytedance/components/plan/plan-info-form.vue'
import CreativeConfigForm from '@/views/create/bytedance/components/creative/creative-form.vue'
import SearchBidKeywordSelectModal from '@/views/create/bytedance/components/project/components/search-bid.vue'
import CarouselMaterialModal from '@/views/create/bytedance/components/creative/components/carousel-material/index.vue'
import Document from '@/views/create/toutiao_local/components/idea/document/document.vue'
import { AssetsSelector } from '@/components/material-selector/index.js'
import { MATERIAL_TYPE, MATERIAL_TYPE_ID } from '@/components/material-selector/consts.js'
import { MATERIAL_TYPE_SIZES } from '@/views/create/bytedance/consts/creative.js'
import {
  AD_TYPE,
  DELIVERY_MODE,
  DELIVERY_MODE_LIST,
  LANDING_TYPE_LIST,
  MARKETING_GOAL_LIST,
  PROJECT_AUDIENCE_TYPE
} from '@/views/create/bytedance/consts/index.js'
import { getProjectFormRules } from '@/views/create/bytedance/rules/index.js'
import { useCreativeSelector } from '@/views/create/bytedance/hooks/useToutiaoCreative.js'

// eslint-disable-next-line
const props = defineProps({
  form: {
    type: Object,
    required: true
  }
})
// eslint-disable-next-line
const emit = defineEmits(['update:form'])

const basicFormRef = ref(null)
const bidFormRef = ref(null)
const targetingFormRef = ref(null)
const planInfoFormRef = ref(null)
const creativeFormRef = ref(null)
const titleSelectorModal = ref(false)
const keywordModalVisible = ref(false)
const showCarouselAddModal = ref(false)
const opId = Cookies.get('ch_op_id')

const configForm = computed({
  get: () => props.form,
  set: (form) => emit('update:form', form)
})
const projectForm = computed(() => props.form.project)
const editContext = computed(() => props.form.editContext || {})
const adAccount = computed(() => props.form.accounts?.[0] || {})
const accountName = computed(() => adAccount.value.name || adAccount.value.adAccount || adAccount.value.advertiserName || adAccount.value.id)
const isProcedural = computed(() => projectForm.value.delivery_mode === DELIVERY_MODE.PROCEDURAL)
const isCustomAudience = computed(() => projectForm.value.audience_type === PROJECT_AUDIENCE_TYPE.CUSTOM)
const landingTypeLabel = computed(() => getOptionLabel(LANDING_TYPE_LIST, editContext.value.landingType))
const marketingGoalLabel = computed(() => getOptionLabel(MARKETING_GOAL_LIST, editContext.value.marketingGoal))
const deliveryModeLabel = computed(() => getOptionLabel(DELIVERY_MODE_LIST, editContext.value.deliveryMode))
const adTypeLabel = computed(() => {
  const labels = {
    [AD_TYPE.ALL]: '通投计划',
    [AD_TYPE.SEARCH]: '搜索计划'
  }
  return labels[editContext.value.adType] || editContext.value.adType || '-'
})

function getOptionLabel(options, value) {
  return options.find((option) => option.value === value)?.label || value || '-'
}

const creativeForm = computed({
  get: () => props.form.creatives[0],
  set: (creative) => {
    emit('update:form', { ...props.form, creatives: [creative] })
  }
})
const creativeFormGroups = computed(() => props.form.creatives)

function updateConfigForm(form) {
  emit('update:form', form)
}

provide('configForm', { configForm, updateConfigForm })
provide('bytedanceVersion', { isV3: computed(() => true) })

function onUpdateCreativeForm(form) {
  creativeFormRef.value?.setForm(form)
}

const {
  showSelectorModal,
  selectorProps,
  seletedMaterialRadioDiasbled,
  onShowCreativeSelector,
  onShowRepalceMaterialSelector,
  onSelectorClose,
  onSelectorConfirm
} = useCreativeSelector(
  () => adAccount.value,
  creativeForm,
  creativeFormGroups,
  onUpdateCreativeForm,
  configForm,
  updateConfigForm
)

const keywordSelection = computed(() =>
  (projectForm.value.keywords || []).map((item) => ({
    keyword: typeof item === 'string' ? item : item.word || item.keyword || '',
    patern: {
      label: typeof item === 'string' ? '广泛' : item.match_type || item.patern?.label || '广泛',
      value: typeof item === 'string' ? 'EXTENSIVE' : item.match_type || item.patern?.value || 'EXTENSIVE'
    }
  }))
)

function onKeywordConfirm(keywords) {
  projectForm.value.keywords = keywords.map((item) => ({
    word: item.keyword,
    bid_type: 'FEED_TO_SEARCH',
    match_type: item.patern.value
  }))
  projectForm.value.keywordsDesc = keywords.length ? `已选${keywords[0].keyword}...共${keywords.length}个关键词` : '未添加关键词'
}

function addTitleItem() {
  const titles = props.form.plan.title_material_list
  if (titles.length < 10) titles.push({ title: '' })
}

async function removeTitleItem(index) {
  const title = props.form.plan.title_material_list[index]
  if (title?._stdExisting) {
    try {
      await MessageBox.confirm('移除后提交将删除媒体侧已有标题，是否继续？', '提示', {
        confirmButtonText: '继续移除',
        cancelButtonText: '取消',
        type: 'warning'
      })
    } catch (e) {
      return
    }
  }
  props.form.plan.title_material_list.splice(index, 1)
}

function onTitleSelectConfirm(titles) {
  const current = props.form.plan.title_material_list
  const availableCount = Math.max(0, 10 - current.length)
  current.push(...titles.slice(0, availableCount).map((title) => ({ title: title.docContent })))
  titleSelectorModal.value = false
}

async function syncChildForms() {
  if (isCustomAudience.value && targetingFormRef.value) {
    await targetingFormRef.value.validate()
    props.form.targetings[0].targetingParamJson = targetingFormRef.value.getForm()
  }
  props.form.plan = planInfoFormRef.value.getForm()
  props.form.creatives = [creativeFormRef.value.getForm()]
}

async function validate() {
  await basicFormRef.value.validate()
  await bidFormRef.value.validate()
  await planInfoFormRef.value.validate()
  await creativeFormRef.value.validate()
  await syncChildForms()
}

watch(
  () => props.form.plan,
  (plan) => {
    nextTick(() => planInfoFormRef.value?.setForm(plan))
  },
  { immediate: true }
)

watch(
  () => props.form.creatives[0],
  (creative) => {
    nextTick(() => creativeFormRef.value?.setForm(creative))
  },
  { immediate: true }
)

watch(
  [isCustomAudience, () => props.form.targetings?.[0]?.targetingParamJson],
  ([custom, targeting]) => {
    if (!custom || !targeting) return
    nextTick(() => targetingFormRef.value?.setForm(clone(targeting)))
  },
  { immediate: true }
)

// eslint-disable-next-line
defineExpose({ validate, syncChildForms })
</script>

<style lang="scss" scoped>
.standard-project-form {
  padding-bottom: 90px;
}

.title-input-row {
  position: relative;
  width: 680px;
  margin-bottom: 10px;

  .remove {
    position: absolute;
    top: -6px;
    right: -6px;
    color: #f56c6c;
    cursor: pointer;
  }
}
</style>
